import type { LightingAdvisorRecommendedProduct } from '~/types/lightingAdvisor';

function sortByRank(
  products: LightingAdvisorRecommendedProduct[]
): LightingAdvisorRecommendedProduct[] {
  return [...products].sort((left, right) => {
    const leftRank = left.rank ?? Number.MAX_SAFE_INTEGER;
    const rightRank = right.rank ?? Number.MAX_SAFE_INTEGER;
    if (leftRank !== rightRank) {
      return leftRank - rightRank;
    }
    return 0;
  });
}

/**
 * Best rank first (1 = top), then API order, de-duplicated.
 * Pass `limit` to cap the result (e.g. 3 for the Category Selector modal);
 * omit it to keep all recommendations (PLP SKU filter).
 */
export function pickRecommendedLightingProducts(
  products: LightingAdvisorRecommendedProduct[] | null | undefined,
  limit?: number
): LightingAdvisorRecommendedProduct[] {
  if (!products?.length) {
    return [];
  }

  const seen = new Set<string>();
  const result: LightingAdvisorRecommendedProduct[] = [];
  for (const item of sortByRank(products)) {
    const sku = item.sku?.trim();
    if (!sku || seen.has(sku)) {
      continue;
    }
    seen.add(sku);
    result.push({ ...item, sku });
    if (limit != null && result.length >= limit) {
      break;
    }
  }

  return result;
}

/** Best rank first (1 = top), then API order. Optional cap via `limit`. */
export function pickRecommendedLightingSkus(
  products: LightingAdvisorRecommendedProduct[] | null | undefined,
  limit?: number
): string[] {
  return pickRecommendedLightingProducts(products, limit).map(
    (item) => item.sku
  );
}
